import { Component, OnInit } from '@angular/core';
import { GlobalStoreService } from '../../services/global-store/global-store.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { ParticulierBancaire } from 'src/app/api/model/particulier-bancaire.model';
import { AdressePhysiqueBancaire } from 'src/app/api/model/adresse-physique-bancaire.model';
import { ProfilCaisse } from 'src/app/api/model/profil-caisse.model';
import { GestionErreurService } from 'src/app/services/gestion-erreur/gestion-erreur.service';
import { Routes } from 'src/app/models/routes.enum';
import { TelephoneBancaire } from 'src/app/api/model/telephone-bancaire.model';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { ConfigMeta } from 'src/app/models/meta';
import { GabaritService } from 'src/app/services/gabarit/gabarit.service';
import { QueryParamsHandling } from '@angular/router';
import { GestionProvenanceService } from '../../services/navigation/gestion-provenance.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-coordonnees',
  templateUrl: './coordonnees.component.html',
  styleUrls: ['./coordonnees.component.scss'],
  standalone: false,
})
export class CoordonneesComponent implements OnInit {
  cleTraductionPlanifierAppelMobile = 'caad.planifier-appel-page.mobile';
  cleTraductionPlanifierAppelWeb = 'caad.planifier-appel-page.web';

  coordonneesMembre?: ParticulierBancaire;
  codeErreur: string = '';
  pagePlanifierAppelMobile: string = '';
  pagePlanifierAppelWeb: string = '';

  constructor(
    private readonly globalStoreService: GlobalStoreService,
    private readonly gestionErreurService: GestionErreurService,
    private readonly gestionProvenanceService: GestionProvenanceService,
    private readonly navigationService: NavigationService,
    private readonly configService: ConfigurationService,
    private readonly gabaritService: GabaritService,
    private readonly translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.gestionErreur();

    this.translateService
      .get(this.cleTraductionPlanifierAppelMobile)
      .subscribe((texte: string) => (this.pagePlanifierAppelMobile = texte));
    this.translateService
      .get(this.cleTraductionPlanifierAppelWeb)
      .subscribe((texte: string) => (this.pagePlanifierAppelWeb = texte));
    this.globalStoreService.getCoordonneesMembre$().subscribe({
      next: (data) => {
        this.coordonneesMembre = data;
      },
    });
  }

  get infoProfilCaisseFolio(): ProfilCaisse[] {
    return this.coordonneesMembre?.adresseCourante?.profilsCaisse ?? [];
  }

  get adressesSpecifiques(): Array<AdressePhysiqueBancaire> {
    return this.coordonneesMembre?.adressesSpecifiques;
  }

  get adresse(): AdressePhysiqueBancaire {
    return this.coordonneesMembre?.adresseCourante;
  }

  get telephonePrincipal(): TelephoneBancaire | undefined {
    return this.coordonneesMembre?.telephones?.find((t) => t.typeLieu === 'RESIDENCE_PRINCIPALE');
  }

  get telephoneSecondaire(): TelephoneBancaire | undefined {
    return this.coordonneesMembre?.telephones
      ?.filter((t) => t.typeLieu === 'AUTRE')
      .sort((a, b) => (a.empreinte < b.empreinte ? 1 : -1))[0];
  }

  get telephoneTravail(): TelephoneBancaire | undefined {
    return this.coordonneesMembre?.telephones?.find((t) => t.typeLieu === 'LIEU_TRAVAIL');
  }

  get courriel(): string {
    return this.coordonneesMembre?.courriel?.adresseCourriel || '';
  }

  get lienCredit(): string {
    return '/' + Routes.CREDIT;
  }

  get lienCreditQueryParamsHandling(): QueryParamsHandling | null {
    return this.gestionProvenanceService.obtenirValeurQueryParamsHandling();
  }

  getUrlPlanifierAppel(): string {
    const urlRappel = this.configService.getValueOrBlank(ConfigMeta.OEL_URL_PLANIFIER_APPEL);
    if (this.gabaritService.isAppMobile()) {
      return urlRappel ? urlRappel + this.pagePlanifierAppelMobile : '';
    } else {
      return urlRappel ? urlRappel + this.pagePlanifierAppelWeb : '';
    }
  }

  allerAModification() {
    this.navigationService.naviguerVersModifierCoordonnees();
  }

  private gestionErreur(): void {
    this.globalStoreService.getEtatErreur().subscribe((erreur) => {
      if (erreur) {
        this.codeErreur = this.gestionErreurService.getCodeErreur(erreur);
        this.navigationService.naviguerVersPageErreurCoordonnees(
          erreur.status.toString(),
          this.codeErreur,
          this.gestionErreurService.getMessageErreur(erreur)
        );
      }
    });
  }
}
